import { Link } from "react-router-dom";

/**
 * Reusable shell for static legal pages (Privacy / Terms / Data Deletion).
 * Public — does not require authentication. Matches the dashboard's
 * African Polistas brand styling.
 */
export function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div
      className="min-h-screen px-6 py-10"
      style={{ background: "hsl(var(--ap-paper))" }}
      data-testid="legal-page"
    >
      <div className="mx-auto max-w-3xl">
        {/* Header */}
        <header className="mb-10 flex items-center gap-4 border-b pb-6 border-black/10">
          <img
            src="/logo.png"
            alt="African Polistas"
            className="h-12 w-12 rounded-xl shadow-sm bg-white p-1"
          />
          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              African Polistas. Operations Dashboard
            </p>
            <h1
              className="font-serif text-3xl text-[hsl(var(--ap-forest))] mt-1"
              data-testid="legal-page-title"
            >
              {title}
            </h1>
            {lastUpdated && (
              <p className="text-xs text-muted-foreground mt-1">
                Last updated: {lastUpdated}
              </p>
            )}
          </div>
        </header>

        {/* Body */}
        <article
          className="prose prose-sm max-w-none leading-relaxed text-foreground/90 space-y-5 [&_h2]:font-serif [&_h2]:text-xl [&_h2]:text-[hsl(var(--ap-forest))] [&_h2]:mt-8 [&_h2]:mb-2 [&_h3]:font-medium [&_h3]:text-base [&_h3]:mt-5 [&_h3]:mb-1 [&_a]:text-[hsl(var(--ap-forest))] [&_a]:underline [&_a]:underline-offset-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
          data-testid="legal-page-body"
        >
          {children}
        </article>

        {/* Footer nav */}
        <footer className="mt-14 pt-6 border-t border-black/10 flex flex-wrap gap-6 text-xs text-muted-foreground">
          <Link to="/privacy" className="hover:text-[hsl(var(--ap-forest))]">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-[hsl(var(--ap-forest))]">
            Terms of Service
          </Link>
          <Link
            to="/data-deletion"
            className="hover:text-[hsl(var(--ap-forest))]"
          >
            Data Deletion
          </Link>
          <span className="ml-auto">
            © {new Date().getFullYear()} African Polistas
          </span>
        </footer>
      </div>
    </div>
  );
}

export default LegalLayout;
